import { createSelector } from 'reselect'

export const getSavedFiltersLoading = createSelector(
  state => state && state.user && state.user.profile
    && state.user.profile.savedFilters
  ? state.user.profile.savedFilters.isLoading : false,
 	isLoading => isLoading
)
